import { IEVersion } from '@/lib/tools';
/**
 * 获取 blob
 * @param  {String} url 目标文件地址
 * @return {Promise}
 */
function getBlob(url) {
    return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();

        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
            if (xhr.status === 200) {
                resolve(xhr.response);
            }
        };

        xhr.send();
    });
}

/**
 * 保存
 * @param  {Blob} blob
 * @param  {String} filename 想要保存的文件名称
 */
function saveAs(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
    } else {
        const link = document.createElement('a');
        const body = document.querySelector('body');

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        // fix Firefox
        link.style.display = 'none';
        body.appendChild(link);

        link.click();
        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
    }
}
/**
 * 下载
 * @param  {String} url 目标文件地址
 * @param  {String} filename 想要保存的文件名称
 */
function download(url, filename) {
    getBlob(url).then((blob) => {
        saveAs(blob, filename);
    });
}
/**
 * downloadFile文件下载方法
 * @param {string} url 文件下载地址
 * @param {string} name 文件名字 形如:a.b.c
 * @param {string} type 下载方式  oss：阿里云下载 不传参或0是普通下载
 * @param {string} source 文件来源  0：三人行 1：教研网 2研修网 3课程
 */
const downloadFile = function(url, name, type = 0, source = 0) {
    let OSS = {};
    if (type == 'oss') {
        return new Promise((resolve) => {
            let OSSData;
            var arrUrl = url.split('//');
            var start = arrUrl[1].indexOf('/');
            var relUrl = arrUrl[1].substring(start); // 截取从start开始到结尾的所有字符
                G_transmit('getChunkUploadToken', {
                    name: 'getChunkUploadToken',
                    data: {
                        moduleType: 'material',
                        publicRead: true
                    },
                    message: false
                }).then((res) => {
                    const uploadData = {
                        ...res.data
                    };
                    OSSData = {
                        region: uploadData.ossRegion,
                        endpoint: uploadData.endpoint,
                        accessKeyId: uploadData.accessKeyId,
                        accessKeySecret: uploadData.accessKeySecret,
                        bucket: uploadData.bucketName,
                        stsToken: uploadData.securityToken
                    };
                    let client = new OSS(OSSData);
                    let dUrl = decodeURI(relUrl);
                    let downUrl = client.signatureUrl(dUrl);
                    // 兼容ie下载时候跳转
                    if (IEVersion() == -1 || IEVersion() == 'edge') {
                        window.location.href = downUrl;
                    } else {
                        // 避免页面下载跳转
                        var downFile = {};
                        if (typeof downFile.iframe == 'undefined') {
                            var iframe = document.createElement('iframe');
                            downFile.iframe = iframe;
                            document.body.appendChild(downFile.iframe);
                        }
                        downFile.iframe.src = downUrl;
                        downFile.iframe.style.display = 'none';
                    }
                    resolve(res.success);
                });
        });
    } else {
        // 教研网直接下载
        if (source == 1) {
            // 兼容ie下载时候跳转
            if (IEVersion() == -1 || IEVersion() == 'edge') {
                window.location.href = url;
            } else {
                // 避免页面下载跳转
                var downFile = {};
                if (typeof downFile.iframe == 'undefined') {
                    var iframe = document.createElement('iframe');
                    downFile.iframe = iframe;
                    document.body.appendChild(downFile.iframe);
                }
                downFile.iframe.src = url;
                downFile.iframe.style.display = 'none';
            }
            return;
        }

        download(url, name);
    }
};
export default downloadFile;